import { FC } from 'react';

/**
 * Иконка мегафона для VersionUpdateDialog.
 *
 * Геометрия совпадает с Material `campaign` (бывш. `MdCampaign`), но три луча
 * звука вынесены в отдельные `<path>`, чтобы анимировать их независимо от
 * корпуса. Сама анимация «Эфир» (выброс лучей + отдача корпуса) живёт в
 * VersionUpdateDialog.scss и завязана на CSS-переменную `--rf-vu-beat`.
 */
const AnnounceMegaphone: FC = () => (
    <svg
        className="rf-version-update__mega"
        viewBox="0 0 24 24"
        width={24}
        height={24}
        aria-hidden="true"
        focusable="false"
    >
        {/* Раструб с ручкой и дуга у рта — статичная база. */}
        <g className="rf-version-update__mega-horn">
            <path d="M4 9c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v4h2v-4h1l5 3V6L8 9H4z" />
            <path d="M15.5 12c0-1.33-.58-2.53-1.5-3.35v6.69c.92-.81 1.5-2.01 1.5-3.34z" />
        </g>

        {/* Три полоски-луча — «звук», выходящий из раструба. */}
        <path
            className="rf-version-update__ray rf-version-update__ray--top"
            d="M20.4 5.6c-.4-.53-.8-1.07-1.2-1.6-.99.74-2.24 1.68-3.2 2.4.4.53.8 1.07 1.2 1.6.96-.72 2.21-1.65 3.2-2.4z"
        />
        <path className="rf-version-update__ray rf-version-update__ray--mid" d="M18 11h4v2h-4z" />
        <path
            className="rf-version-update__ray rf-version-update__ray--bot"
            d="M16 17.61c.96.71 2.21 1.65 3.2 2.39.4-.53.8-1.07 1.2-1.6-.99-.74-2.24-1.68-3.2-2.4-.4.54-.8 1.08-1.2 1.61z"
        />
    </svg>
);

export default AnnounceMegaphone;
